import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getStorage, removeStorage, setStorage } from "./storage";
const AppContext = createContext({
    login: () => { },
})

const AppProvider = ({ children }) => {
    console.log("children", children);

    const navigate = useNavigate()

    const login = async (instance, id) => {
        console.log("login instance", instance);

        setInstance(instance, id)
        navigate("/p/" + id)
    }

    const setInstance = (instance, id) => {
        console.log("setInstance", instance)
        if (instance) {
            setStorage("token", instance.token)
            setStorage("id", id)
        }
        else {
            removeStorage("token")
        }
    }

    useEffect(() => {
        if (getStorage("token")) {
            setInstance({ token: getStorage("token") })
        }
    }, [])

    return <AppContext.Provider value={{ login }}>
        {children}
    </AppContext.Provider>
}

export const useApp = () => useContext(AppContext)
export default AppProvider